import type { MessageInstance } from 'antd/es/message/interface'

// The antd `message` instance from <AntdApp> (context-aware, themed) is only
// reachable inside React; the QueryClient's MutationCache lives outside it.
// <MessageBridge/> in App.tsx stores the instance here.
let instance: MessageInstance | null = null

export const setGlobalMessage = (m: MessageInstance) => { instance = m }
export const getGlobalMessage = () => instance
